import customUpload from './components/upload.vue';
export default customUpload;
